<template>
    <div class="c-app flex-row align-items-center">
      <CContainer style="display: flex; justify-content: center" class="p-0">
        <div class="container-box center">
          <div class="text-left">
            <div class="card-custom-web">
              <br />  
              
              <div class="list-grade" @click="OpenSession()">
                <div class="float-left">
                  <label class="ml-3">Remaining Session</label>
                  <br />
                  <label class="ml-3 sub-title-card text-black"> {{ recur.sessionName }} </label>
                </div>
                <div class="float-right">
                  <img
                    class="mt-3"
                    src="../../assets/img/icon/VectorRight.svg"
                  />
                </div>
                <div style="clear: both"></div>
                <hr />
              </div>

              <div class="list-grade">
                <div class="float-left">
                  <label class="ml-3">Class Frequency</label>
                  <br />
                  <label class="ml-3 sub-title-card text-black"> Weekly </label>
                </div>
                <!-- <div class="float-right">
                  <img
                    class="mt-3"
                    src="../../assets/img/icon/VectorRight.svg"
                  />
                </div> -->
                <div style="clear: both"></div>
                <hr />
              </div>              
              
            </div>
          </div>
        </div>
      </CContainer>

      <CModal size="md" :show.sync="SessionRemaining">
      <div class="text-center">
        <h3 class="custom-title-popup" style="color: #000a2c">
          Remaining Session
        </h3>
        <br />
      </div>
      <div class="text-center">
        <h4 class="sub-title-header" style="color: #000a2c">
          You have {{ recur.sessionName }} remaining with {{ studentName }}
        </h4>
        <br />
      </div>
      <!-- <div class="text-center">
        <CButton class="btn-select-blue mt-5">No, I Change My Mind</CButton>
      </div> -->
      <div class="text-center">
        <CButton class="btn-select-blue mt-2" @click="GoToSelectSession(scheduleId)">
          I want to add more sessions
        </CButton>
      </div>
    </CModal>
      
      <div class="header-top">Tutor Detail</div>
      <div class="header-left">
        <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
      </div>
      <div style="clear: both"></div>
      
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        SessionRemaining: false,
        UploadModal: false,
        recur: {},
        user: {},
        childProfileAuthorize: "",
        childs: [],
        parent: [],
        scheduleId: this.$route.query.scheduleId,
        studentName: this.$route.query.studentName,
      };
    },
    async mounted() {
      let isAuth = await this.UserAuth();
  
      if (isAuth) {
        this.Busy = false;
        this.GetInfoUser();
      } else {
        this.GoToLogin();
      }
    },
    methods: {
      GetInfoUser() {
        return this.$API
          .get(this.$LoginUserDetailWebs, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.user = response.data;
              // this.GetProfileStudentsByStudentId();
              this.GetRecurrence(this.$route.query.scheduleId);
            }
          });
      },
      // GetProfileStudentsByStudentId() {
      //   this.$API
      //     .get(
      //       this.$GetStudentDetailByStudentId +
      //         "?studentId=" +
      //         this.$route.query.studentId,
      //       {
      //         withCredentials: true,
      //       }
      //     )
      //     .then((response) => {
      //       if (response.status == 200 && response.data != null) {
      //         this.students = response.data;
      //       }
      //     });
      // },

      GetRecurrence() {
        this.$API
          .get(
            this.$GetScheduleRecurringById + 
              "?scheduleId=" +
              this.$route.query.scheduleId,
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.recur = response.data;
            }
          });
      },

      OpenSession() {
        this.SessionRemaining = true;
      },
    
      GoToSelectSession(scheduleId) {
        this.$router.push(
          "SelectSessionRecurring?scheduleId=" + scheduleId
        );
      },
      
      GoToFrequency() {
        this.$router.push(
          "SelectClassFrequency" 
        );
      },
    
      GoBack() {
        this.$router.back();
      },
    },
  };
  </script>
  
  <style scoped>
  @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
  
  input {
    border-bottom: 2px solid #dbdbdb;
    background: none;
    border-top: none;
    border-left: none;
    border-right: none;
    width: 90%;
  }
  
  input ::placeholder {
    color: #e0e0e0;
  }
  
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #e0e0e0;
  }
  .c-app {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  }
  .custom-bg-color {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    /* Clickable/Light */
  
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    margin: 0px 20px;
    display: flex;
    justify-content: center;
  }
  body {
    font-family: "Montserrat", sans-serif;
  }
  
  .class-teach-name {
    padding: 4px 1px;
    top: 45px;
    /* height: 40px; */
  
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
  
    /* Pure/White */
  
    color: #ffffff;
  
    /* Inside auto layout */
  
    /* flex: none;
    order: 0;
    flex-grow: 0; */
  }
  .custom-btn-add {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
  
    color: #007cef;
  }
  .custom-btn-deactive {
    position: absolute;
    left: 0%;
    right: 0.61%;
    top: 0%;
    bottom: 0%;
  
    /* Body/1/Semibold */
  
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    /* identical to box height, or 24px */
  
    color: #f85954;
  }
  .custom-text-deactive {
    position: absolute;
    width: 162px;
    height: 22px;
    left: 107px;
    top: 25px;
  
    /* Title/1/Semibold */
  
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    /* identical to box height */
  
    text-align: center;
  
    /* Black/Dark-001 */
  
    color: #000a2c;
  }
  </style>